export default function (params) {
  const data = params.data;
  const width = params.width;
  const height = params.height;
  const innerRadius = params.innerRadius;
  const outerRadius = params.outerRadius;
  const dataColumns = params.dataColumns;

  const svg = d3
    .select("#energyChart")
    .append("svg")
    .attr("id", "bar-svg")
    .attr("viewBox", `${-width / 2} ${-height / 2} ${width} ${height}`)
    .attr("width", width)
    .attr("height", height)
    .style("font", "10px sans-serif");

  const arc = d3
    .arc()
    .innerRadius((d) => y(d[0]))
    .outerRadius((d) => y(d[1]))
    .startAngle((d) => x(d.data.time))
    .endAngle((d) => x(d.data.time) + x.bandwidth())
    .padAngle(0.01)
    .padRadius(innerRadius);

  const x = d3
    .scaleBand()
    .domain(data.map((d) => d.time))
    .range([0, 2 * Math.PI])
    .align(0);

  const y0 = d3
    .scaleLinear()
    .domain([0, d3.max(data, (d) => d.kWh)])
    .range([innerRadius * innerRadius, outerRadius * outerRadius]);

  const y = Object.assign((d) => Math.sqrt(y0(d)), y0);

  const z = d3.scaleOrdinal().domain(dataColumns).range(d3.schemeCategory10);

  const stack = d3.stack().keys(dataColumns);
  const series = stack(data);

  svg
    .append("g")
    .selectAll("g")
    .data(series)
    .enter()
    .append("g")
    .attr("fill", (d) => z(d.key))
    .selectAll("path")
    .data((d) => d)
    .enter()
    .append("path")
    .attr("d", arc);

  // xAxis
  svg
    .append("g")
    .attr("text-anchor", "middle")
    .call((g) =>
      g
        .selectAll("g")
        .data(data)
        .enter()
        .append("g")
        .attr(
          "transform",
          (d) =>
            `rotate(${
              ((x(d.time) + x.bandwidth() / 2) * 180) / Math.PI - 90 - 7.5
            }) translate(${outerRadius}, 0)`
        )
        .call((g) =>
          g
            .append("line")
            .attr("x1", -(width * 0.11))
            .attr("y1", 0)
            .attr("x2", -(width * 0.03))
            .attr("y2", 0)
            .attr("stroke", "#AAAAAA")
        )
        .call((g) =>
          g
            .append("line")
            .attr("x1", width * 0.03)
            .attr("y1", 0)
            .attr("x2", width * 0.04)
            .attr("y2", 0)
            .attr("stroke", "#000000")
        )
        .call((g) =>
          g
            .append("text")
            .attr("transform", `rotate(90)translate(0,-${width * 0.05})`)
            .text((d) => d.time)
        )
    );
}
